import { Component, OnDestroy, OnInit } from '@angular/core';
import { SubSink } from 'subsink';

// --- Environments ---
import { environment } from '@environments/environment';

// --- PrimeNG ---
import { PrimeNGConfig } from 'primeng/api';

// --- Facades ---
import { AuthFacade } from '@facades/auth.facade';
import { CartFacade } from '@facades/cart.facade';

// --- Utils ---
import { ptBR } from '@utils/pt-calendar.util';

// --- Interfaces ---
import { EUserProfileIds } from '@interfaces/user';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
	private subs = new SubSink();

	constructor(
		private _primeNGConfig: PrimeNGConfig,
		private authFacade: AuthFacade,
		private cartFacade: CartFacade
	) {}

	ngOnInit() {
		this.setPrimeNGConfig();
		this.setVersions();
		this.handleServiceWorker();
		this.handleCacheDeletion();
		this.handleUserCartUpdate();
	}

	ngOnDestroy() {
		this.subs.unsubscribe();
	}

	private setPrimeNGConfig() {
		this._primeNGConfig.ripple = true;
		this._primeNGConfig.setTranslation(ptBR);
	}

	private setVersions() {
		const appRoot = document.querySelector('app-root');

		const attributes = [
			{ name: 'app-version', value: environment.appVersion },
			{ name: 'api-version', value: environment.apiVersion },
		];

		for (const { name, value } of attributes)
			appRoot?.setAttribute(name, value);
	}

	private handleServiceWorker() {
		if (!window.navigator && !navigator.serviceWorker) return;

		// removendo o service-worker
		navigator.serviceWorker.getRegistrations().then(registrations => {
			const hasActiveRegistrations = registrations.length > 0;
			if (!hasActiveRegistrations) return;
			for (const registration of registrations) registration.unregister();
		});
	}

	private async handleCacheDeletion() {
		const cacheNames = await caches.keys();
		if (!cacheNames.length) return;

		await Promise.all(cacheNames.map(name => caches.delete(name)));
		console.log('All caches cleared');
	}

	private handleUserCartUpdate() {
		this.subs.add(
			this.authFacade.authState$.subscribe(({ user }) => {
				if (!user) return;

				const { updateCartReq } = this.cartFacade;
				const isCustomer = user.profileId === EUserProfileIds.CUSTOMER;
				const isCustomerAdmin =
					user.profileId === EUserProfileIds.CUSTOMER_ADMIN;

				if (updateCartReq && (isCustomer || isCustomerAdmin)) {
					this.cartFacade.updateCart();
					this.cartFacade.updateCartReq = false;
				}
			})
		);
	}
}
